import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import UserProfile from '../components/user/UserProfile';
import AddressManagement from '../components/user/AddressManagement';
import { useAuth } from '../context/AuthContext';

const ProfilePage: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState(0);
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect to login if not authenticated
  if (!loading && !isAuthenticated) {
    return <Navigate to="/login" />;
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          My Account
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your profile information and addresses
        </Typography>
      </Box>
      
      <Paper sx={{ mb: 4 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Profile" />
          <Tab label="Addresses" />
        </Tabs>
      </Paper>
      
      {activeTab === 0 && (
        <UserProfile />
      )}
      
      {activeTab === 1 && (
        <AddressManagement />
      )}
    </Container>
  );
};

export default ProfilePage; 